<template>
    <div class="popup popup-dest panel-left-destination panel-left-comm cruise_search cruise-search-popup" 
    :class="{in: isShow}"
    id="panel-left-destination" data-type="row">
        <div class="popup-head">
            <a @click="goBack()" class="js-returnDetailBtn">
                <img src="https://resource.rcclchina.com.cn/homePage/mobile/leftalllow.png" alt="">
            </a>
            选择目的港
        </div>
        <div class="dest-area search-form-container" data-key="DestinationCode">
            <div class="area-select dest-fir">
                <div v-for="(subCategory, i) in groupSubCategories" :key="i" 
                :class="{ active: currentGroupIndex == i}" @click="changeGroup(i)">
                    <div class="area-select-line"></div>
                    <div class="area-select-name" v-html="getSubCategoryName(subCategory)">
                    </div>
                </div>
            </div>
            <div class="area-country-select select-fir" ref="selectCountry">
                <div class="area-country" v-for="(subCategory, i) in groupSubCategories" :key="i" :class="{ active: i == currentGroupIndex }">
                    <DestinationGroupForm 
                    :cruiseType="cruiseType" 
                    :groups="getFilterGroups(destinations, subCategory)"
                    :destinations="destinations" 
                    :onDestinationListOpen="onDestinationListOpen"
                    :subCategory="subCategory"/>
                
                </div>
            </div>
            <div class="click-btn">
                <a class="reset-btn" @click="onClearClick()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-reset.png" /> 重置</a>
                <a class="define-btn" @click="goBack()"> <img src="https://resource.rcclchina.com.cn/homePage/mobile/mb-define.png"  /> 确定</a>
            </div>
        </div>
    </div>
</template>

<script>
const DestinationGroupForm = () => import('@/components/Home/SearchBar/DestinationGroupForm')
export default {
    name: 'DestinationForm',
    components: {
        DestinationGroupForm
    },
    props: {
        cruiseType: {
            type: String,
            default: function() {
                return "hp"
            }
        },
        destinations: {
            type: Array,
            default: function() {
                return []
            }
        },
        isShow: {
            type: Boolean,
            default: function() {
                return false
            }
        },
        closeForm: {
            type: Function
        }
    },
    data () {
        return {
            currentGroupIndex: 0
        }
    },
    methods: {
        goBack() {
            this.closeForm()
        },
        onClearClick() {
            this.$store.dispatch('RESET_DESTINATION_FILTERS', { cruiseType: this.cruiseType })
        },
        getSubCategoryName (subCategory) {
            if (subCategory.indexOf('/') > 0) {
                return subCategory.split("/").join("<br/>")
            } else {
                return subCategory
            }
        },
        getFilterGroups (destinations, subCategory) {
            let groups = []
            destinations.forEach((destination) => {
                if (destination.cruiseFilterGroupSubCategory == subCategory 
                    && destination.countryName && destination.countryName.length > 0) {
                        const groupName = destination.cruiseFilterGroupName
                        if (!groups.includes(groupName)) {
                            groups.push(groupName)
                        }
                    }
            })
            return groups
        },
        getDestinationsBySubCategory (subCategory) {
            return this.destinations.filter(item => item.cruiseFilterGroupSubCategory == subCategory)
        },
        changeGroup (index) {
            this.currentGroupIndex = index
        },
        onDestinationClear () {
            this.$store.dispatch('RESET_DESTINATION_FILTERS', { cruiseType: this.cruiseType })
        },
        onDestinationListOpen (offsetTop) {
            setTimeout(()=> {
                this.$refs.selectCountry.scroll({ top: offsetTop - 54, behavior: 'smooth'})
            }, 100)
        }
    },
    computed: {
        groupSubCategories () {
            let groupSubCategories = []
            this.destinations.forEach((filter) => {
                const subCategory = filter.cruiseFilterGroupSubCategory
                if (!groupSubCategories.includes(subCategory)) {
                    groupSubCategories.push(subCategory)
                }
            })

            return groupSubCategories
        },
        filterResponseDesinations () {
            return this.$store.state.cruise.filterResponse[this.cruiseType].destinations
        }
    },
    watch: {
        filterResponseDesinations (newOne) {
            // 查找第一个可以选择的sub category
            let availableIndexs = []
            const availableItems = newOne
            this.groupSubCategories.forEach((subCategory, i) => {
                const destinationCodes = this.getDestinationsBySubCategory(subCategory).map(item=>item.filterCode)
                let isNotDisbaleAll = availableItems.some(item=> destinationCodes.includes(item))
                if (isNotDisbaleAll) {
                    availableIndexs.push(i)
                }
            })

            if (availableIndexs.length > 0 && !availableIndexs.includes(this.currentGroupIndex)) {
                this.currentGroupIndex = availableIndexs[0]
            }

        }
    }
}
</script>
